/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_2_HintInputs */

const en_sch_level_2_hint = /** @type {(inputs: Sch_Level_2_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups everyday work. Can sit under initiatives.`)
};

const de_sch_level_2_hint = /** @type {(inputs: Sch_Level_2_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bündelt alltägliche Arbeit. Kann unter Initiativen stehen.`)
};

/**
* | output |
* | --- |
* | "Groups everyday work. Can sit under initiatives." |
*
* @param {Sch_Level_2_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_2_hint = /** @type {((inputs?: Sch_Level_2_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_2_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_2_hint(inputs)
	return en_sch_level_2_hint(inputs)
});